import { FC } from 'react';
import { Typography } from '@mui/material';
import { formatCurrency } from '@acorn-portal/shared/src/utils/formatter';

interface PaymentOptions {
	annualPremium: number;
	insurancePremiumTaxPercentage: number;
	policyAdministrationFee: number;
}

interface PayInFullSummaryProps {
	paymentOptions: PaymentOptions;
}

const PayInFullSummary: FC<PayInFullSummaryProps> = ({ paymentOptions }) => {
	return (
		<>
			<Typography sx={{ fontSize: 16, mt: 2, fontWeight: 'bold', textAlign: 'center' }}>Amount Due Today</Typography>
			<Typography
				sx={{
					fontWeight: 'bold',
					fontSize: 35,
					color: 'secondary.main',
				}}
			>
				{formatCurrency(paymentOptions?.annualPremium)}
			</Typography>
			<Typography
				sx={{
					fontSize: 14,
					borderTop: 1,
					borderColor: 'grey.300',
					pt: 2,
					mt: 2,
					paddingBottom: 2,
				}}
			>
				Prices include insurance premium tax of {paymentOptions.insurancePremiumTaxPercentage}% and a non-refundable
				policy administration fee of {formatCurrency(paymentOptions.policyAdministrationFee)}
			</Typography>
		</>
	);
};

export default PayInFullSummary;
